import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=e10fcff4&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShowProject: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/app/project/showProject.vue').default})
